import React from "react";
import ReactDOM from "react-dom";
import "./css/index.css";
import "./css/mobile_index.css";
import Favicon from "react-favicon";
import App from "./App";
import logo from "./assets/images/CAC-logo.png";
import { Helmet } from "react-helmet";

ReactDOM.render(
  <div>
    <Favicon url={logo} />
    <React.StrictMode>
      <Helmet>
        <title>
          Consular Affairs Center | Honorary | Bibliography | Newsletter | Date
        </title>
        <meta
          name="description"
          content="Consular Affairs Center: The global hub for consular news, honorary consuls, bibliography, newsletter, migration law, travel industry updates, and international relations. Access daily press reviews, newsletters, research, legal resources, and contribute to the world's largest consular knowledge base. Stay updated with the latest consular, honorary, bibliography, newsletter, and date-related information."
        />
        <meta
          property="og:image"
          content="https://consular/blog/wp-content/uploads/2019/12/fb-how-to-become-an-seo-expert.png"
        />
      </Helmet>
      <App />
    </React.StrictMode>
  </div>,
  document.getElementById("root")
);
